"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.snakeCase = exports.isCachedState = exports.LEAD_CACHE_IDENTIFIER = void 0;
const snakeCase_1 = __importDefault(require("lodash/snakeCase"));
exports.LEAD_CACHE_IDENTIFIER = "leadspedia-cache";
function isCachedState(state) {
    return (state === null || state === void 0 ? void 0 : state.__type) === exports.LEAD_CACHE_IDENTIFIER;
}
exports.isCachedState = isCachedState;
const snakeCase = (val) => (val.split(/(\d+)/).map(snakeCase_1.default).join(""));
exports.snakeCase = snakeCase;
//# sourceMappingURL=utils.js.map